import { Button } from 'antd';
import styled from 'styled-components';

import { FlexContainer } from 'utils/layouts/containers';

export const ActionButtons = styled(FlexContainer)`
  justify-content: flex-end;

  .left-btn {
    margin-right: auto;
  }
`;

export const LeftButton = styled(Button)`
  margin-right: auto;
`;

export const RightButton = styled(Button)`
  margin-left: 0.5rem;
`;
